import type { AIFlow } from '@src/aiFlow/AIFlow';
import type { RootStore } from '@src/stores-v2/RootStore';
import type { AIPrompt } from '@src/types.ts/ai_prompts';

export async function enrichAIFlowWithImpactScore(
  aiFlow: AIFlow,
  rootStore: RootStore,
): Promise<{ prompt: AIPrompt | undefined }> {
  const prompt = await getImpactScorePrompt(rootStore);

  addToAIFlowContext(aiFlow, prompt);

  addImpactScoreToStepsConfigIfUsed(aiFlow, prompt);

  return { prompt };
}

function addToAIFlowContext(aiFlow: AIFlow, prompt: AIPrompt | undefined) {
  if (!aiFlow.context) {
    aiFlow.context = {};
  }
  aiFlow.context['AIPrompt.impactScore'] = prompt?.description;
}

async function getImpactScorePrompt(
  rootStore: RootStore,
): Promise<AIPrompt | undefined> {
  // Prefer the customer's impact score prompt (resolved from their customer
  // type, with inheritance) when one is set; otherwise fall back to the global
  // "Impact Score" prompt (the default behavior).
  const customerPrompt =
    rootStore.templatedPromptsStore.aiImpactScoreTemplate ?? undefined;
  if (customerPrompt) {
    return customerPrompt;
  }

  try {
    return await rootStore.datoClientStore.aiPromptRepository.getPromptByTitle(
      'Impact Score',
    );
  } catch (err) {
    console.error('Error while fetching impact score prompt', err);
  }
  return undefined;
}

function addImpactScoreToStepsConfigIfUsed(
  aiFlow: AIFlow,
  prompt: AIPrompt | undefined,
): void {
  if (!prompt?.description) {
    return;
  }
  for (const step of aiFlow.steps) {
    if (step.userPromptTemplate?.includes('{{AIPrompt.impactScore}}')) {
      step.config.impactScoreKeys = prompt.promptFields.map(f => f.name);
    }
  }
}
